import React, { useCallback, useContext, useMemo, useState } from 'react';
import { notification, Form } from 'antd';
import { useQuery } from 'react-query';
import {
  AssetListSearchResponse,
  getAssetListByAnyRef,
  GetAssetListByAnyRefParams,
} from '../../services/assets';

import { getFinAssetListByAnyRef } from '../../services/finassets';

import { toCurrency } from 'utils/utils';
import DataGrid from 'components/DataGrid';

import ParListSelect from 'components/ParListSelect';
import { DataGridColDef, DataGridProps } from 'components/DataGrid/DataGrid';

import Modal from 'antd/lib/modal/Modal';
import InputCurrency from 'components/InputCurrency';
import { indexBy, shouldUpdateCompare } from 'utils/utils2';
import { useEffect } from 'react';
import { AuthContext } from 'components/Auth/Auth';
import ButtonOperation from 'components/ButtonOperation';

type AssetListProps = Pick<DataGridProps<any>, 'rowSelection'> & {
  phase: 'PROPOSAL' | 'PROD';
  status?: any;
  visible?: boolean;
  alreadySelected: Array<Number>;
  onCancel: () => void;
  validate: any;
  nbreAsset?: any;
  assetClass?:string;
};

const AssetListModalV = (props: AssetListProps) => {
  const initialSearchParams: GetAssetListByAnyRefParams = {
    assetreference: '',
    assetlabel: '',
    clientname: '',
    clientreference: '',
    ctreference: '',
    deliveryreference: '',
    orderreference: '',
    propreference: '',
    refsupplier: '',
    suppliername: '',
    status: '', //props.status,
    phase: props.status,
    chassisno: '',
    plateno: '',
    assetclass:props.assetClass ?? ''
  };

  const [searchParams, setSearchParams] =
    useState<GetAssetListByAnyRefParams>(initialSearchParams);

  const { validate, onCancel, phase, nbreAsset ,assetClass} = props;
  const [searchs, setsearchs] = useState(false);
  const [form] = Form.useForm();
  const { isInspect } = useContext(AuthContext);
  const [assetList, setassetList] = useState<any[]>([]);

  const {
    data: assets,
    isFetching,
    refetch,
  } = useAssets(searchParams, props.phase, searchs, props.status);

  useEffect(() => {
    if (assets) {
      var newList: AssetListSearchResponse[] = [];

      assets?.forEach((asset: any) => {
        if (
          props.alreadySelected.findIndex((e) => e === asset.assetid) === -1
        ) {
          newList.push({
            ...asset,
            assetfinamount:
              asset?.irvamountout > asset?.finamountout
                ? asset?.irvamountout > asset?.marketvalue
                  ? asset?.irvamountout
                  : asset?.marketvalue
                : asset?.finamountout > asset?.marketvalue
                ? asset?.finamountout
                : asset?.marketvalue,
          });
        }
      });

      form.setFieldsValue({ assetlist: newList });
    }
  }, [
    form,
    assets,
    props?.visible,
    props.status,
    props?.alreadySelected,
    props.phase,
  ]);

  const getName = useCallback(
    (name: string) => (record: any) => {
      const assetlist = form.getFieldValue('assetlist');
      const index = indexBy(assetlist, 'assetid')[record.assetid];
      return ['assetlist', index, name];
    },
    [form]
  );
  const columns = useMemo<DataGridColDef<AssetListSearchResponse>[]>(
    () => [
      {
        dataIndex: 'assetreference',
        filtrable: true,
        fixed: 'left',
        width: 150,
      },
      {
        dataIndex: 'assetlabel',
        filtrable: true,
        width: 300,
      },
      {
        dataIndex: 'propreference',
        filtrable: phase !== 'PROPOSAL' ? true : false,
        width: 150,
      },

      {
        dataIndex: 'status',
        filterComponent: (
          <ParListSelect parcode="ASSETSTAT" style={{ width: '100%' }} />
        ),
        render: (val, record) => record.statuslabel,

        width: 120,
      },
      {
        dataIndex: 'refsupplier',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'suppliername',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'clientreference',
        filtrable: true,
        width: 150,
      },
      {
        dataIndex: 'clientname',
        filtrable: true,
        width: 150,
      },

      {
        dataIndex: 'assettypelabel',
        width: 150,
      },
      {
        dataIndex: 'assetcategorylabel',
        width: 200,
      },

      {
        dataIndex: 'orderreference',
        width: 100,
      },
      {
        dataIndex: 'deliveryreference',
        width: 100,
      },

      {
        dataIndex: 'assetgrossamount',
        width: 150,
        align: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        dataIndex: 'assetnetamount',
        align: 'right',
        width: 150,
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        dataIndex: 'marketvalue',
        align: 'right',
        width: 150,
        fixed: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        dataIndex: 'irvamountout',
        align: 'right',
        width: 150,
        fixed: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        dataIndex: 'finamountout',
        align: 'right',
        width: 150,
        fixed: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        dataIndex:
          props.status === 'INIT' ? 'finassetamountin' : 'assetfinamount',
        align: 'right',
        width: 150,
        fixed: 'right',
        render: (_val, _record, index) =>
          props.status === 'INIT' ? (
            toCurrency(_val, _record.currcode)
          ) : (
            <InputCurrency
              noStyle
              key={index}
              value={_val}
              currcode={_record.currcode}
              disabled={props.status === 'INIT'}
              fieldname={getName(
                props.status === 'INIT' ? 'finassetamountin' : 'assetfinamount'
              )(_record)}
              onChange={(e) => {
                /**
                 * Optimisation
                 * replace return by return res
                 */
                let _assets = assetList?.map((asset) => {
                  return asset?.assetid === _record?.assetid
                    ? {
                        ...asset,
                        assetfinamount: e,
                      }
                    : false;
                });
                setassetList([..._assets]);
              }}
            />
          ),
      },
      {
        dataIndex: 'assetclasslabel',
        filtrable: true,
        filterComponent:<ParListSelect parcode='ASSETCLASS'/>,
        width: 150,
      },
    ],
    [getName, props.status, assetList]
  );

  return (
    <Modal
      visible={props.visible}
      title="Asset List"
      onCancel={onCancel}
      footer={[
        <ButtonOperation
          key="Cancel"
          comcode="Cancel"
          type="default"
          onClick={() => {
            !isInspect && onCancel();
          }}
        />,
        <ButtonOperation
          key="validate"
          comcode="Validate"
          type="primary"
          onClick={() => {
            !isInspect && validate(assetList);
          }}
          loading={!props.visible}
        />,
      ]}
      width="1200px"
      style={{ top: 20, right: 0 }}
      destroyOnClose
    >
      <Form form={form} preserve={false}>
        <Form.Item noStyle shouldUpdate={shouldUpdateCompare('assetlist')}>
          {({ getFieldValue }) => (
            <DataGrid
              scroll={{ x: 1500, y: 400 }}
              titleComcode={
                props.status === 'INIT'
                  ? 'pageTitleAssetInit'
                  : 'pageTitleAssetStock'
              }
              dataSource={(getFieldValue('assetlist') as any) ?? []}
              rowKey={(record) => record?.assetid}
              pagination={{ pageSize: 400 }}
              columns={
                props.status === 'INIT'
                  ? columns
                      .filter((ea) => ea.dataIndex !== 'finamountout')
                      .filter((ea) => ea.dataIndex !== 'irvamountout')
                      .filter((ea) => ea.dataIndex !== 'marketvalue')
                  : columns
              }
              hideExtraAction
              initialSearchValues={initialSearchParams}
              onSearch={(values) => {
                setSearchParams({
                  ...values,
                });
                setsearchs(true);
                refetch();
              }}
              isLoading={isFetching}
              rowSelection={
                props.rowSelection ?? {
                  type: nbreAsset ? 'radio' : 'checkbox',
                  onChange: (selectedRowKeys, selectedRows) => {
                    setassetList(selectedRows);
                  },
                  hideSelectAll: true,
                }
              }
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const useAssets = (
  searchParams: any,
  assetPhase: string,
  run: boolean,
  status: string
) => {
  const statusAsset = assetPhase === 'PROPOSAL' ? 'INIT' : '';
  const phaseAsset = assetPhase === 'PROD' ? 'STOCKIN' : 'INIT';
  const assetsQuery = useQuery(
    ['getAssetListByAnyRef', searchParams, statusAsset, phaseAsset, assetPhase],
    () =>
      getAssetListByAnyRef({
        ...searchParams,
        status: statusAsset,
        phase: phaseAsset,
      })
        .then((res) => res.list || [])
        .catch((error) => {
          notification.error({
            description: error.message,
            message: 'Asset Service is not available',
          });
          return [];
        }),
    { enabled: assetPhase === 'PROPOSAL' && run, refetchOnWindowFocus: false } //, staleTime: 1000 * 60 }
  );

  const finAssetsQuery = useQuery(
    [
      'getFinAssetListByAnyRef',
      searchParams,
      statusAsset,
      phaseAsset,
      assetPhase,
    ],
    () =>
      getFinAssetListByAnyRef({
        ...searchParams,
        status: statusAsset,
        phase: phaseAsset,
      }).then((res) => res.list || []),
    { enabled: assetPhase === 'PROD' && run, refetchOnWindowFocus: false } //, staleTime: 1000 * 60 }
  );

  return assetPhase === 'PROPOSAL' ? assetsQuery : finAssetsQuery;
};

export default AssetListModalV;
